export default "__VITE_ASSET__BubOZW9P__"